'use client';

import LoginModal from '@/components/modals/login-modal';
import ClientProvider from '@/providers/client-provider';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import { ConfigProvider, theme } from 'antd';
import { ThemeProvider, useTheme } from 'next-themes';
import { ReactNode } from 'react';
interface Props {
  defaultTheme: string;
  children: ReactNode;
}
export default function ThemeProviders({ defaultTheme, children }: Props) {
  return (
    <AntdRegistry>
      <ThemeProvider attribute='class' defaultTheme='dark' enableSystem>
        <AntDesignProvider defaultTheme={defaultTheme}>
          {children}
        </AntDesignProvider>
      </ThemeProvider>
    </AntdRegistry>
  );
}

function AntDesignProvider({ defaultTheme, children }: Props) {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const { theme: currentTheme = defaultTheme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: currentTheme === 'light' ? defaultAlgorithm : darkAlgorithm,
      }}
    >
      {children}
      <ClientProvider>
        <LoginModal />
      </ClientProvider>
    </ConfigProvider>
  );
}
